import {
  CheckCircleOutlineOutlined,
  CloseOutlined,
  ErrorOutlineOutlined,
} from "@mui/icons-material";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import React from "react";
import { useAppSelector } from "../../store/hooks";
import { RootState } from "../../store/store";

export interface IProps {
  open: boolean;
  handleClose: () => void;
}

const MessageDialog: React.FC<IProps> = ({ open, handleClose }) => {
  const { isSuccess, isError, message } = useAppSelector(
    (state: RootState) => state.common
  );
  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      id="message_dialog"
      data-test-id="message_dialog"
      aria-label="Message dialog"
    >
      <DialogTitle 
        sx={{ display: "flex", justifyContent: "flex-end" }}
        id="message_dialog_title"
        data-test-id="message_dialog_title"
        aria-label="Message dialog title"
      >
        <IconButton 
          onClick={handleClose}
          id="message_dialog_close_button"
          data-test-id="message_dialog_close_button"
          aria-label="Close message dialog"
        >
          <CloseOutlined />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
        }}
        id="message_dialog_content"
        data-test-id="message_dialog_content"
        aria-label="Message dialog content"
      >
        {isSuccess ? (
          <CheckCircleOutlineOutlined
            sx={{ fontSize: "60px", color: "green" }}
            id="message_dialog_success_icon"
            data-test-id="message_dialog_success_icon"
            aria-label="Success icon"
          />
        ) : isError ? (
          <ErrorOutlineOutlined 
            sx={{ fontSize: "60px", color: "red" }}
            id="message_dialog_error_icon"
            data-test-id="message_dialog_error_icon"
            aria-label="Error icon"
          />
        ) : (
          <></>
        )}
        <DialogContentText 
          color={isError ? "red" : ""}
          id="message_dialog_text"
          data-test-id="message_dialog_text"
          aria-label={message || (isSuccess ? "Success" : isError ? "Error occurred" : "")}
        >
          {message
            ? message
            : isSuccess
            ? "Success"
            : isError
            ? "Something went wrong please try again"
            : ""}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        id="message_dialog_actions"
        data-test-id="message_dialog_actions"
        aria-label="Message dialog actions"
      ></DialogActions>
    </Dialog>
  );
};

export default MessageDialog;
